// src/hooks/termOfPayments/useRestoreAllTermOfPayments.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllTermOfPayments } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useRestoreAllTermOfPayments = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAllTermOfPaymentsMutation, isPending } = useMutation({
        mutationFn: restoreAllTermOfPayments,
        onSuccess: (res) => {
            const message = res?.message || "Term of payments restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore term of payments");
        },
    });

    return { restoreAllTermOfPaymentsMutation, isPending };
};

export default useRestoreAllTermOfPayments;